import StripePaymentBlock from './StripePaymentBlock';
import CashPaymentBlock from './CashPaymentBlock';
import NetRatePaymentBlock from './NetRatePaymentBlock';

function PaymentBlock({
    order,
    allOrders,
    paymentMethod,
    onStartTransaction,
    onCancel,
    amount,
    maxAmount,
}) {
    // based on the paymentMethod.paymentType, this is a simple switch
    switch (paymentMethod.methodType) {
        // net_rate is charged as an ordinary guest card payment (the booking is
        // already priced at net); it reuses the Stripe card entry UI.
        case 'stripe':
        case 'net_rate':
            return (
                <StripePaymentBlock
                    order={order}
                    allOrders={allOrders}
                    paymentMethod={paymentMethod}
                    onStartTransaction={onStartTransaction}
                    onCancel={onCancel}
                    amount={amount}
                    maxAmount={maxAmount}
                />
            );
        case 'cash':
            return (
                <CashPaymentBlock
                    order={order}
                    allOrders={allOrders}
                    paymentMethod={paymentMethod}
                    onStartTransaction={onStartTransaction}
                    onCancel={onCancel}
                    amount={amount}
                    maxAmount={maxAmount}
                />
            );
        case 'net_rate_company':
            return (
                <NetRatePaymentBlock
                    order={order}
                    allOrders={allOrders}
                    paymentMethod={paymentMethod}
                    onStartTransaction={onStartTransaction}
                    onCancel={onCancel}
                    amount={amount}
                    maxAmount={maxAmount}
                />
            );
    }
    return <div>Unknown payment method: {JSON.stringify(paymentMethod)}</div>;
}

export default PaymentBlock;
